import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router';

window.mylocale = navigator.language;

//////////////////////////////////////////
////////////    Routes
import main_page from './components/main_page'
import pickup from './components/pickup_form'
import manage from './components/manage'

const routes = [
  { path: '/', component: main_page },
  { path: '/pickup', component: pickup },
  { path: '/manage', component: manage }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

//////////////////////////////////////////
//////////    Store
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({

  state () {
    return {
      auth: false,
      login: false,
      user_data: null,
    }
  },

  mutations: {

    setauth (state, val) {
      state.auth = val
    },
    setlogin (state, val) {
      state.login = val
    },
    setuserdata (state, val) {
      state.user_data = val  
    }

  }

})
//////////////////////////////////////////
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDtizF_kSOQ45HBNb9B6intb_o1IMv_Fiw', // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  installComponents: true, // Optional (default: true) - false, if you want to locally install components
  vueGoogleMapsCompatibility: false, // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
});

//////////////////////////////////////////
//////////    AUTH CHECK
router.beforeEach((to, from, next) => {

  if( !store.auth ) {
    if ( to.path == '/pickup' || to.path == '/manage' || to.path == '/manage' ) {
      store.commit('setlogin', true)
    }
  }

  if (to.query.code) {
    console.log('https://idn1dgbtvl.execute-api.eu-central-1.amazonaws.com/default/helloworld?code=' + to.query.code + '&redirect_uri=' + window.location.origin + to.path)
    axios
    .get('https://idn1dgbtvl.execute-api.eu-central-1.amazonaws.com/default/helloworld?code=' + to.query.code + '&redirect_uri=' + window.location.origin + to.path)
    .then( function(response) {
      store.commit('setauth', response.data.auth)
      store.commit('setlogin', !response.data.auth)
      store.commit('setuserdata', response.data.pifdata)
    }).catch(function (error) {console.log(error)})
  }
  next()
})

Vue.config.productionTip = false
Vue.use(VueRouter)
window.app = new Vue({
  el: '#app',
  router: router,
  store: store,
  vuetify,
  render: h => h(App)
})
